<template lang="pug">
b-modal#textModal.modal.fade(
  scrollable,
  centered,
  hide-footer="",
  :header-class="divider ? '' : 'border-0 pb-0'",
  :body-class="contentCenter ? 'text-center' : ''",
  :title="title",
  tabindex="-1",
  aria-labelledby="textModal",
  aria-hidden="true"
)
  slot(name="content")
</template>

<script>
export default {
  name: "DialogText",
  props: {
    title: String,
    divider: Boolean,
    contentCenter: Boolean,
  },
};
</script>

<style scoped lang="scss">
@media only screen and (max-width: 767px) {
  ::v-deep h5 {
    font-weight: 300 !important;
  }
}
</style>
